import { transformEnumToDisplay } from '@fruitful/member-profile';
import type { ColumnEditorOptions } from 'primereact/column';

import { DropdownEditor } from '../../../common/components/GridCellEditors';
import { TaxFiling } from '../../../entities/entityTypes';

export const TaxFilingEditor = (options: ColumnEditorOptions) => {
    const taxFilings = Object.values(TaxFiling).map((taxFiling) => ({
        label: transformEnumToDisplay(taxFiling),
        value: taxFiling,
    }));

    return (
        <DropdownEditor
            options={options}
            dropdownProps={{
                options: taxFilings,
                placeholder: 'Select Tax Filing',
            }}
        />
    );
};
